import React from 'react';
import { Table,Modal } from 'tea-component'
const {
    scrollable,
} = Table.addons;



const ExplainTable = (props:any) => {
    const { columns, data } = props
    return (
        <Table
            className='pit-model'
            records={data}
            verticalTop={true}
            columns={columns}
            addons={[
                // 支持表格滚动，高度超过 342px 开始显示滚动条
                scrollable({
                    maxHeight: 600,
                    //onScrollBottom: () => console.log("到达底部"),
                }),
            ]}
        />
    )
}

const RainbowTableModal = (props:any) => {
    const {data,columns, caption, visible, setVisible} = props;

    return (
        <Modal
            size="l"
            visible={visible}
            caption={caption}
            onClose={() => setVisible(false)}
        >
            <Modal.Body>
                <ExplainTable columns={columns} data={data} />
            </Modal.Body>
        </Modal>
    )
}

export default RainbowTableModal